module.exports = __webpack_public_path__ + "static/media/1-what-is-a-colonoscopy-general-03-1-x@3x.2fc21417.png";